import React from 'react';

export function ModeSwitch({ mode, onVoice, onText }) {
  return React.createElement(
    'div',
    { className: 'mode-switch' },
    React.createElement(
      'button',
      { className: 'mode-btn ' + (mode === 'voice' ? 'selected' : 'ghost'), type: 'button', onClick: onVoice },
      'Voice'
    ),
    React.createElement(
      'button',
      { className: 'mode-btn ' + (mode === 'text' ? 'selected' : 'ghost'), type: 'button', onClick: onText },
      'Text'
    )
  );
}
